
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class LiquidMetalEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const blobs = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < blobs; i++) {
                const rx = Math.sin(curTime * 0.5 + i) * width;
                const ry = Math.cos(curTime * 0.5 + i * 2) * height;
                const r = (100 + this.pseudoRandom(i) * 200) * scale * (1 / (layerIndex + 1));
                
                const grad = ctx.createRadialGradient(rx, ry, 0, rx, ry, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(0.5, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.save();
                ctx.globalAlpha *= 0.3;
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(rx, ry, r, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
